import i18n from "i18next";
import { updateLatestVMPNotificationId } from './slice';
import StateListenerRegistry from '../base/redux/StateListenerRegistry';
import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
import { showNotification, showWarningNotification } from '../notifications/actions.any';
import { NOTIFICATION_TIMEOUT_TYPE } from '../notifications/constants';
/**
 * Registers a change handler for state['features/base/conference'].conference to
 * set the event listeners needed for the A/V moderation feature to operate.
 */
StateListenerRegistry.register((state) => state['features/base/conference'].conference, (conference, { getState, dispatch }, previousConference) => {
    if (conference && !previousConference) {
        conference.on(JitsiConferenceEvents.VT_VMP_NOTIFICATION_RECEIVED, ({ notification }) => {
            const { latestVMPNotificationId } = getState()["features/vmp-notification"];
            if (latestVMPNotificationId !== notification.id) {
                dispatch(updateLatestVMPNotificationId(notification.id));
                if (notification.type === 'expire-warning') {
                    const [notiContent, notiValue] = notification.contentValue?.split(':') || [];
                    if (notiContent && notiValue) {
                        dispatch(showWarningNotification({
                            uid: 'EXPIRE_WARNING_NOTIFICATION_ID',
                            titleKey: i18n.t(`notify.${notiContent}`, { duration: Math.round(Number(notiValue)) }),
                        }, NOTIFICATION_TIMEOUT_TYPE.STICKY));
                    }
                }
                else {
                    dispatch(showNotification({
                        descriptionKey: notification.contentValue,
                        appearance: notification.type
                    }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
                }
            }
        });
    }
});
